import React, {useEffect} from 'react';
import {View, StyleSheet} from 'react-native';
import GameNotification, {GameNotification as NotificationType} from './GameNotification';

interface GameNotificationOverlayProps {
  notifications: NotificationType[];
  onDismiss: (id: string) => void;
}

const GameNotificationOverlay: React.FC<GameNotificationOverlayProps> = ({
  notifications,
  onDismiss,
}) => {
  useEffect(() => {
    // Auto-dismiss les notifications après leur durée
    notifications.forEach(notification => {
      if (notification.duration && notification.duration > 0) {
        const timer = setTimeout(() => {
          onDismiss(notification.id);
        }, notification.duration);

        return () => clearTimeout(timer);
      }
    });
  }, [notifications, onDismiss]);

  if (notifications.length === 0) {
    return null;
  }

  return (
    <View style={styles.container} pointerEvents="box-none">
      {notifications.map(notification => (
        <GameNotification
          key={notification.id}
          notification={notification}
          onDismiss={onDismiss}
        />
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    top: 100, // En dessous du header invisible (insets.top + ~60-80px)
    left: 0,
    right: 0,
    zIndex: 1000,
    alignItems: 'center', // Centrer les notifications
    paddingHorizontal: 24,
  },
});

export default GameNotificationOverlay;
